import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocument = () => {
  return (
    <g>
      <path d="m14.4845.0425h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5236a.7433.7433 0 0 0 -.2158.55v10.871a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.4146a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.02h-2.02zm8.918 12.3849h-11.4687v-8.8646h3.3008a.75.75 0 0 0 .75-.75v-3.3h7.418z" />
    </g>
  );
};

export default withIcon(IconDocument);
